<template>
	<div class="consultAndReply" >
    <div class="consult">
      <div class="title">
        {{consult.title}}
      </div>
      <div class="brief">
        <span class="subject">{{owner}}</span>
        <span class="date">{{ date }}</span>
        <span class="replyCount">{{consult.replys.length}}个回答</span>
      </div>
      <div class="name">问题描述</div>
      <div class="content">
        {{ consult.content }}
      </div>
    </div>
    <div v-if="consult.replys.length>0">
      <div class="replys">
        <ReplyDetailBox v-for="(item, index) in consult.replys" :reply="item" :title="consult.title"></ReplyDetailBox>
      </div>
    </div>
	</div>
</template>

<script>
import { getChatTime } from '@/utils/date'
import ReplyDetailBox from '@/components/consult/replyDetailBox.vue'
export default {
  name: 'ConsultDetailBox',
  props: {
    consult: {},
    isMy: Boolean,
  },
  components: {
    ReplyDetailBox,
  },
  computed: {
    date() {
      return getChatTime(new Date(this.consult.createTime))
    },
    owner() {
      return this.isMy?'我':'有人'
    }
  },

  methods: {
    handleClick() {
        this.$emit('playMission',this.missionId)
    },
  }
}
</script>

<style lang="stylus" scoped>
.consultAndReply
  margin-top :0.24rem
.consult
  margin: 0 0.24rem
  padding: 0.1rem 0.3rem 0.2rem 0.3rem
  background: #fff;
  border:1px #BBBBBB solid;
  .title
    color:#008DCF
  .brief
    margin-top:0.12rem
    font-size :0.24rem
    color:#999
    .subject
      padding-right:0.12rem
    .date
      padding-right:0.12rem
    .replyCount
      padding-right:0.12rem
  .name
    font-size: 0.28rem
    margin: 0.26rem 0 0.06rem 0
    color:#777
  .content
    font-size:0.24rem
    color:#101010
    margin-top:0.1rem
    // max-height:0.9rem
    line-height:0.3rem

.replys
  margin: 0.24rem
  padding: 0.1rem 0.3rem 0.2rem 0.3rem
  background: #fff;
  border:1px #BBBBBB solid;
</style>
